<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-info">
        <p class="company">
          <strong>{{ $t("footer.company") }}</strong>
        </p>
        <p class="address">{{ $t("footer.address") }}</p>
        <p class="mobile">{{ $t("footer.mobile") }}</p>
        <p class="email">
          {{ $t("footer.emailLabel") }}:
          <a href="mailto:cabbeen@ycinvest.com">cabbeen@ycinvest.com</a>
        </p>
        <p class="website">{{ $t("footer.website") }}</p>
        <div class="follow-us">
          <div class="social-links">
            <a class="social-link social-xhs" href="https://www.xiaohongshu.com/user/profile/67d001e4000000000e01088f?...=" target="_blank" rel="noopener" aria-label="Xiaohongshu">
              <img class="social-icon" src="@/assets/images/小红书.png" alt="Xiaohongshu" />
            </a>
            <a class="social-link social-ins" href="https://www.instagram.com/cabbeen.my/?igsh=aWhpaXl1ODVuY2Jw#" target="_blank" rel="noopener" aria-label="Instagram">
              <img class="social-icon" src="@/assets/images/IG.png" alt="Instagram" />
            </a>
            <a class="social-link social-tiktok" href="https://www.tiktok.com/@cabbeen.my?_t=ZS-8wrTVR0GPPs&_r=1" target="_blank" rel="noopener" aria-label="TikTok">
              <img class="social-icon" src="@/assets/images/tiktok.png" alt="TikTok" />
            </a>
            <a class="social-link social-facebook" href="https://www.facebook.com/people/Cabbeen-Malaysia/61573840030138/?mibextid=wwXIfr&rdid=XmAlFfoDFbR5jGBl&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F16TA7wUjTk%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener" aria-label="Facebook">
              <img class="social-icon" src="@/assets/images/facebook.png" alt="Facebook" />
            </a>
            <a class="social-link social-whatsapp" href="https://www.whatsapp.com/channel/0029VbATZrZEawdjq9UsEJ03" target="_blank" rel="noopener" aria-label="WhatsApp">
              <img class="social-icon" src="@/assets/images/what.png" alt="WhatsApp" />
            </a>
          </div>
        </div>
        <p class="code">{{ $t("footer.code") }}</p>
      </div>

      <!-- 右侧三栏（PC为三列，移动端纵向） -->
      <div class="footer-nav">
        <!-- 栏目一：卡宾商城 -->
        <div class="nav-col">
          <div class="nav-title">{{ $t('footer.nav.shopTitle') }}</div>
          <ul class="nav-list">
            <li><router-link class="nav-link" to="/store">{{ $t('footer.nav.onlineStore') }}</router-link></li>
            <li><a class="nav-link" :href="storeLinks.lazada" target="_blank" rel="noopener">{{ $t('footer.nav.lazada') }}</a></li>
            <li><a class="nav-link" :href="storeLinks.shopee" target="_blank" rel="noopener">{{ $t('footer.nav.shopee') }}</a></li>
            <li><a class="nav-link" :href="storeLinks.tiktok" target="_blank" rel="noopener">{{ $t('footer.nav.tiktokShop') }}</a></li>
          </ul>
        </div>
        <!-- 栏目二：联系我们 -->
        <div class="nav-col">
          <div class="nav-title">{{ $t('footer.nav.contactTitle') }}</div>
          <ul class="nav-list">
            <li><router-link class="nav-link" to="/contact">{{ $t('footer.nav.globalHQ') }}</router-link></li>
            <li><router-link class="nav-link" to="/brand-cooperation">{{ $t('footer.nav.brandCooperation') }}</router-link></li>
            <li><router-link class="nav-link" to="/mall-leasing">{{ $t('footer.nav.mallLeasing') }}</router-link></li>
            <li><router-link class="nav-link" to="/recruitment">{{ $t('footer.nav.recruitment') }}</router-link></li>
          </ul>
        </div>
        <!-- 栏目三：关于卡宾 -->
        <div class="nav-col">
          <div class="nav-title">{{ $t('footer.nav.aboutTitle') }}</div>
          <ul class="nav-list">
            <li><router-link class="nav-link" to="/about">{{ $t('navbar.about') }}</router-link></li>
            <li><router-link class="nav-link" to="/offline-store">{{ $t('footer.nav.offlineStore') }}</router-link></li>
            <li><router-link class="nav-link" to="/news">{{ $t('footer.nav.news') }}</router-link></li>
            <li><router-link class="nav-link" to="/recruitment">{{ $t('footer.nav.recruitment') }}</router-link></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-copyright">
      <p class="terms">{{ $t("footer.terms") }}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      isMobile: false,
      // 商城平台外链（如后续有正式链接可在此更新）
      storeLinks: {
        lazada: "https://www.instagram.com/cabbeen.my/?igsh=aWhpaXl1ODVuY2Jw#",
        shopee: "https://www.instagram.com/cabbeen.my/?igsh=aWhpaXl1ODVuY2Jw#",
        tiktok: "https://www.instagram.com/cabbeen.my/?igsh=aWhpaXl1ODVuY2Jw#",
      },
    };
  },
  mounted() {
    this.checkWindow();
    window.addEventListener('resize', this.checkWindow);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkWindow);
  },
  methods: {
    checkWindow() {
      this.isMobile = window.innerWidth < 768;
    },
  },
};
</script>

<style scoped>
.app-footer {
  background-color: #1a1a1a;
  color: #fff;
  padding: 10px 0;
  text-align: left;
  position: relative;
  z-index: 1;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 1px;
  gap: 15px;
}

.footer-info {
  width: 100%;
  padding-left: 40px; /* 让左侧信息整体右移一点（仅PC端） */
}

.footer-info p {
  margin: 10px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.footer-info .company {
  font-weight: 700;
  font-size: 16px;
  color: #fff;
}

.follow-us {
  display: flex;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
}

.follow-title {
  color: #fff;
  font-size: 14px;
}

.social-links {
  display: flex;
  align-items: center;
  gap: 12px;
}

.social-link {
  display: inline-flex;
  align-items: center;
}

.social-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  border-radius: 8px;
}

/* 右侧三栏 */
.footer-nav {
  display: grid;
  grid-template-columns: repeat(3, minmax(160px, 1fr));
  gap: 30px;
}

.nav-col {}

.nav-title {
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 12px;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-link {
  display: inline-block;
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  padding: 6px 0;
}

.nav-link:hover {
  color: #f39c12;
}

.footer-copyright {
  text-align: center;
  margin-top: 20px;
  padding: 5px 0;
  border-top: 1px solid #444;
}

.footer-copyright p {
  margin: 10px 0;
  font-size: 13px;
}

/* 响应式 */
@media (max-width: 768px) {
  .app-footer {
    padding: 10px 16px;
  }
  .footer-content {
    flex-direction: column;
    text-align: left;
    align-items: flex-start;
    padding: 0;
  }
  .footer-info {
    width: 100%;
    margin-bottom: 20px;
    padding-left: 0; /* 移动端不右移 */
  }
  /* 移动端显示为单列纵向排列 */
  .footer-nav {
    display: block;
    width: 100%;
    margin-top: 10px;
  }
  .nav-col { margin-bottom: 16px; }
  .nav-title { font-size: 15px; margin-bottom: 8px; }
  .nav-link { padding: 8px 0; font-size: 14px; }
}
</style>
